import styled from 'styled-components/macro';

export const Well = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 1px solid #a0a0a0;
  margin: 1rem 0;
  padding: 1rem;
`;
